import styled, { css } from 'styled-components'
import { tabletBreakpoint, desktopBreakpoint, mobileBreakpoint } from 'react-components'

export const OffsetContainer = styled.section.attrs({ as: 'div' })`
    padding-top: 0.25rem;
    margin-top: -0.25rem;
`

export const FooterWrapper = styled(OffsetContainer).attrs({ as: 'footer' })<{ hideFooterWrapper?: boolean }>(
    ({ theme, hideFooterWrapper }) => css`
        ${!!hideFooterWrapper && 'display: none;'}
        width: ${theme.layout.fill};
        background-color: ${theme.colors.tfwBlack3};
        border-top: ${theme.typography.border.radius.xxxSmall} solid ${theme.colors.tfwBlackOpacity10};
    `,
)

export const GridWrapper = styled(FooterWrapper)`
    padding-top: 0;
    margin-top: 0;
    background-color: ${({ theme }) => theme.colors.white};
    position: absolute;
    z-index: 10;
`

export const InnerContainerWrapper = styled.div`
    max-width: 79.75rem;
    margin: 0 auto;
    background-color: ${props => props.theme.colors.tfwBlack3};
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: ${props => props.theme.spacing.xxLarge} ${props => props.theme.spacing.large}
            ${props => props.theme.spacing.xLarge};
    }
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 3.75rem ${props => props.theme.spacing.large} ${props => props.theme.spacing.xxxLarge};
    }
`

export const InnerGridWrapper = styled(InnerContainerWrapper)`
    background-color: ${({ theme }) => theme.colors.white};
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: ${props => props.theme.spacing.large} ${props => props.theme.spacing.large};
    }
`

export const Container = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    padding: ${props => props.theme.spacing.xLarge} 0;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 0;
        flex-wrap: nowrap;
    }
`

export const ImageWrapper = styled.div`
    display: flex;
    padding: ${props => props.theme.spacing.large};
    padding-right: ${props => props.theme.spacing.xSmall};
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: ${props => props.theme.spacing.large} 0;
        justify-content: flex-start;
    }
`

export const LogoImage = styled.a`
    display: flex;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        justify-content: flex-start;
        align-items: center;
    }
`

export const LogoImagePic = styled.img`
    height: 2.25rem;

    @media only screen and (max-width: ${mobileBreakpoint.max}px) {
        width: ${props => props.theme.layout.fill};
    }

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        height: 2.5rem;
    }
`

export const Image = styled.img`
    height: ${props => props.theme.layout.xSmall};
    width: ${props => props.theme.layout.small};

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        width: ${props => props.theme.layout.xSmall};
        height: ${props => props.theme.layout.small};
    }
`

export const IconContainer = styled.div`
    display: flex;
    padding: ${props => props.theme.spacing.large};
    padding-left: ${props => props.theme.spacing.xSmall};
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: ${props => props.theme.spacing.large} 0;
        justify-content: ${props => props.theme.style.justifyContent.center};
    }
`
export const IconUl = styled.ul`
    padding: 0;
    margin: 0;
    list-style: none;
    line-height: 1.6rem;
`
export const IconLi = styled.li`
    display: inline-block;
    padding: 0 0.188rem;
    border-radius: 100%;
    border: ${props => props.theme.typography.border.radius.xxxSmall} solid ${props => props.theme.colors.white};
    transition-duration: 0.5s;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        border: ${props => props.theme.typography.border.radius.xxxSmall} solid ${props => props.theme.colors.tfwBlack3};
        :hover {
            border: ${props => props.theme.typography.border.radius.xxxSmall} solid
                ${props => props.theme.colors.tfwBlack87};
        }
    }
`

export const IconContent = styled.a`
    display: flex;
    cursor: pointer;
    padding: 0.625rem ${props => props.theme.spacing.xxSmall};

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 0.625rem;
    }
`

export const MenuWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 1.25rem 1.5rem;
    margin: 0 auto;
    max-width: 79.75rem;
    height: ${props => props.theme.layout.fill};
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        overflow: unset;
        padding: 0;
        margin-bottom: 1.25rem;
    }
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        margin-bottom: ${props => props.theme.spacing.large};
    }
`
